import { filter } from "rxjs/operators"
import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Input,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"

@Component({
	selector: "app-confirm",
	imports: [COMMON_IMPORTS, LangValPipe, CancelBtnComponent, SafeHtmlPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="confirm-modal">
			<div class="col-12">
				@if (objectName) {
					<p>{{ objectName }}</p>
				}
				@if (freeText) {
					<p [innerHTML]="freeText | safeHtml"></p>
				}
			</div>
		</div>

		<div class="modal-btns">
			@if (!avoidCancel) {
				<app-cancel-btn (click)="onClose.emit()" />
			}
			<ng-content />
			<button
				#confirmBtn
				class="btn btn-primary"
				(click)="onClose.emit(true)"
			>
				{{ confirmText || "confirm" | langVal }}
			</button>
		</div>
	`,
})
export class ConfirmComponent extends Modalable {
	isErrorOpen: boolean = false
	@Input() objectName: string = "" //the name of the object to be displayed (example: patient to be deleted)
	@Input() freeText: string = ""
	@Input() confirmText: string = ""
	@Input({ transform: booleanAttribute }) avoidCancel: boolean = false
	@ViewChild("confirmBtn") confirmBtn: ElementRef //the confirm btn, needed for focus

	ngAfterViewInit() {
		setTimeout(() => this.confirmBtn.nativeElement.focus())
	}
}
